module.exports = __webpack_public_path__ + "img/record-vinyl.c6d44a23.svg";